import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.large || '1.25rem'};
  margin-top: ${({ theme }) => theme.spacing.large || '1.25rem'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium || '0.9375rem'};
  }
`;

export default Row;
